(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview-external/assets/javascripts/coupon-overview-external.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview-external/assets/javascripts/coupon-overview-external.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useRef = _React.useRef;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const Brand = svs.ui.ReactBrand;
const useBranding = svs.components.tipsen.hooks.useBranding;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectTotalAmountOfRows = _svs$components$tipse.selectTotalAmountOfRows,
  selectIsExternalMsys = _svs$components$tipse.selectIsExternalMsys;
const useCouponContext = svs.components.tipsen.couponComponents.useCouponContext;
const CouponOverviewExternal = () => {
  const _useBranding = useBranding(),
    _useBranding2 = _slicedToArray(_useBranding, 1),
    productBranding = _useBranding2[0];
  const currentDate = useRef(new Date());
  let hours = currentDate.current.getHours();
  let minutes = currentDate.current.getMinutes();
  if (hours < 10) {
    hours = '0'.concat(hours);
  }
  if (minutes < 10) {
    minutes = '0'.concat(minutes);
  }
  const timeUploaded = "".concat(hours, ":").concat(minutes);
  const draw = useCurrentDraw();
  const regCloseTime = draw.regCloseTime;
  const _useCouponContext = useCouponContext(),
    couponId = _useCouponContext.couponId;
  const totalAmountOfRows = useSelector(state => selectTotalAmountOfRows(state, couponId));
  const isExternalMSYS = useSelector(state => selectIsExternalMsys(state, couponId));
  let label = 'Enkelrader';
  if (isExternalMSYS) {
    label = 'M-System';
  }
  return React.createElement("div", {
    className: "pg_coupon_overview_external"
  }, React.createElement("div", {
    className: "pg_coupon_overview_external__heading"
  }, "Produkt"), React.createElement("div", {
    className: "pg_coupon_overview_external__value"
  }, React.createElement(Brand, {
    brand: productBranding,
    size: 300,
    square: true
  })), React.createElement("div", {
    className: "pg_coupon_overview_external__heading"
  }, "Uppladdad"), React.createElement("div", {
    className: "pg_coupon_overview_external__value"
  }, timeUploaded), React.createElement("div", {
    className: "pg_coupon_overview_external__heading"
  }, "Klient"), React.createElement("div", {
    className: "pg_coupon_overview_external__value"
  }, "Filuppladdning"), React.createElement("div", {
    className: "pg_coupon_overview_external__heading"
  }, "Spelstopp"), React.createElement("div", {
    className: "pg_coupon_overview_external__value"
  }, "".concat(formatDate(regCloseTime, true, true, false))), React.createElement("div", {
    className: "pg_coupon_overview_external__heading"
  }, "Antal rader"), React.createElement("div", {
    className: "pg_coupon_overview_external__value"
  }, "".concat(totalAmountOfRows)), React.createElement("div", {
    className: "pg_coupon_overview_external__heading"
  }, "Systemtyp"), React.createElement("div", {
    className: "pg_coupon_overview_external__value"
  }, "".concat(label)));
};
setGlobal('svs.components.tipsen.couponOverviewExternal.CouponOverviewExternal', CouponOverviewExternal);

 })(window);